import {UserAuthClaims} from "crqlar-react-common/dist/models/auth/userAuthClaims.model";
import {MixpanelService} from "crqlar-react-common/dist/services/analytics/mixpanel.service";

export const syncMixpanelAuth = (claims?: UserAuthClaims) => {
    if (claims?.user) {
        MixpanelService.getInstance().onLogin(claims);
        return;
    }

    MixpanelService.getInstance().reset();
};
